
  // document.addEventListener("DOMContentLoaded", function () {
  //   const inputField = document.getElementById('inputNumber');
  //   const searchButton = document.getElementById('validate');
  //   const fakeBtn = document.querySelector('.disabled-fake-button');
  //   const validateWrapper = document.getElementById('validate-wrapper');
  
  //   // Función para buscar coincidencias
  //   function findMatch() {
  //     const inputValue = inputField.value.trim(); // Obtener el valor del input, eliminando espacios
  //     if (inputValue === "") {
  //       console.log("Por favor, ingresa un número.");
  //       return;
  //     }
  
  //     // Buscar si el número existe en el array
  //     if (window.vet_ids_array.includes(inputValue)) {
  //       console.log(`¡Match encontrado! El número ${inputValue} existe en el array.`);
  //       fakeBtn.style.display = 'none';
  
  //       // Verificar si la cookie ya existe
  //       if (getCookie('validated_number')) {
  //         console.log('ya existe cookie');
  //       } else {
  //         // Si no existe la cookie, crearla con 72 horas de duración
  //         setCookie('validated_number', inputValue, 3); // 3 días = 72 horas
  //         console.log('Cookie creada con el número:', inputValue);
  //       }
  //     } else {
  //       console.log(`No se encontró el número ${inputValue} en el array.`);
  //     }
  //   }
  
  //   // Función para establecer una cookie
  //   function setCookie(name, value, days) {
  //     let expires = "";
  //     if (days) {
  //       const date = new Date();
  //       date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // 72 horas
  //       expires = "; expires=" + date.toUTCString();
  //     }
  //     document.cookie = name + "=" + (value || "") + expires + "; path=/";
  //   }
  
  //   // Función para obtener el valor de una cookie
  //   function getCookie(name) {
  //     const nameEQ = name + "=";
  //     const ca = document.cookie.split(';');
  //     for (let i = 0; i < ca.length; i++) {
  //       let c = ca[i];
  //       while (c.charAt(0) === ' ') c = c.substring(1, c.length);
  //       if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  //     }
  //     return null;
  //   }
  
  //   // Agregar evento al botón
  //   searchButton.addEventListener('click', findMatch);
  // });

  document.addEventListener("DOMContentLoaded", function () {
    const inputField = document.getElementById('inputNumber');
    const searchButton = document.getElementById('validate');
    const hiddenInput = document.getElementById('vet-id');
    const fakeBtn = document.querySelector('.disabled-fake-button');
    const validationForm = document.getElementById('validate-wrapper');
    const buyBtn = document.getElementById('buy-button-wrapper');

    // buyBtn.style.display = buyBtn.classList.contains?'none':'flex'; checar con chatgpt para targetear solo ma :)
    buyBtn.style.display = 'none';

    // Verificar si la cookie ya tiene un valor
    const validatedNumber = getCookie('validated_number');
    if (validatedNumber) {
        // Si la cookie existe, asignar su valor al input oculto #vet-id
        hiddenInput.value = validatedNumber;
        validationForm.style.display = 'none';
        fakeBtn.style.display = 'none';
        buyBtn.style.display = 'flex';
        console.log('Cookie encontrada, valor asignado a Vet ID:', validatedNumber);
    }

    function findMatch() {
        const inputValue = inputField.value.trim(); 
        if (inputValue === "") {
            console.log("Por favor, ingresa un número.");
            return;
        }
  
        // Validar contra el array de IDs
        if (window.vet_ids_array.includes(inputValue)) {
            console.log(`¡Match encontrado! El número ${inputValue} existe en el array.`);
            fakeBtn.style.display = 'none';

            // Asigna el valor validado al input oculto
            hiddenInput.value = inputValue;
            buyBtn.style.display = 'flex';

            // Crear la cookie si no existe
            if (!getCookie('validated_number')) {
                setCookie('validated_number', inputValue, 3); // 3 días = 72 horas
                console.log('Cookie creada con el número:', inputValue);
            } else {
                console.log('Cookie ya existe');
                hiddenInput.value = inputValue;
            }

            if (validationForm) {
              validationForm.style.display = 'none';
          }

        } else {
            console.log(`No se encontró el número ${inputValue} en el array.`);
        }
    }
  
    // Función para establecer una cookie
    function setCookie(name, value, days) {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000)); // 72 horas
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
  
    // Función para obtener el valor de una cookie
    function getCookie(name) {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }
  
    searchButton.addEventListener('click', findMatch);
});
